import { ChatProviderIdEnum, EmailProviderIdEnum } from '../../types';
export const CONVERSATIONAL_PROVIDERS = [
    { providerId: ChatProviderIdEnum.Slack, displayName: 'Slack' },
    { providerId: ChatProviderIdEnum.Telegram, displayName: 'Telegram' },
    { providerId: ChatProviderIdEnum.WhatsAppBusiness, displayName: 'WhatsApp Business' },
    { providerId: ChatProviderIdEnum.MsTeams, displayName: 'MS Teams' },
    { providerId: EmailProviderIdEnum.NovuAgent, displayName: 'Novu Email', requiresBusinessTier: true },
    { providerId: ChatProviderIdEnum.Discord, displayName: 'Discord', comingSoon: true },
    { providerId: 'google-chat', displayName: 'Google Chat', comingSoon: true },
    { providerId: 'linear', displayName: 'Linear', comingSoon: true },
    { providerId: 'zoom', displayName: 'Zoom', comingSoon: true },
    { providerId: 'imessages', displayName: 'iMessages', comingSoon: true },
];
export const CONVERSATIONAL_PROVIDER_IDS = new Set(CONVERSATIONAL_PROVIDERS.map((p) => p.providerId));
//# sourceMappingURL=conversational-providers.js.map